.narrow {
  max-width: 460px;
  width: 100%;
}

.lead {
  color: var(--text-secondary);
  margin: -8px 0 24px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr));
  gap: 16px;
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 20px;
  font-size: 14px;
}

.links a,
.inlineLink {
  color: var(--accent-strong);
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 760px;
}

.sectionTitle {
  margin: 0 0 16px;
  font-size: 20px;
}

.sessionList {
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.session {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px 16px;
  align-items: center;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 12px 16px;
}

.sessionMeta {
  color: var(--text-muted);
  font-size: 13px;
}

.badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: var(--radius-pill);
  background: var(--accent-soft);
  color: var(--accent-strong);
  font-size: 12px;
  font-weight: 600;
}

.secret {
  font-family: var(--font-mono);
  overflow-wrap: anywhere;
  background: var(--surface-soft);
  border-radius: var(--radius-sm);
  padding: 10px 12px;
}

.balances {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 180px), 1fr));
  gap: 12px;
  margin: 0 0 20px;
}

.balances div {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 12px 16px;
}

.balances dt {
  color: var(--text-muted);
  font-size: 13px;
}

.balances dd {
  margin: 4px 0 0;
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 600;
}

.subTitle {
  margin: 0 0 12px;
  font-size: 16px;
}

.amount {
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
}
